<template>
  <div id="search-variey-box">
    <v-layout align-center justify-center row v-if="varietyDetails.length" wrap>
      <v-flex sm6 xs11>
        <div class="headline head-page font-weight-bold">
          <slot>{{ varietyDetails.length }} สายพันธุ์</slot>
        </div>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center row wrap>
      <v-flex sm6 xs11>
        <v-layout row wrap>
          <v-flex
            class="mouse-pointer"
            @click="onClickVariety(varietyDetail.varietyid, varietyDetail.varietyname)"
            :key="index"
            pr-1
            pt-0
            v-for="(varietyDetail, index) in varietyDetails.slice(0, 3)"
            xs3
          >
            <v-card color="transparent" elevation="0">
              <v-img
                :aspect-ratio="4 / 4"
                class="grey lighten-2"
                cover
                :lazy-src="require('@/assets/NoPicture.png')"
                :src="
                  varietyDetail.mainpictureurl
                    ? varietyDetail.mainpictureurl
                    : require('@/assets/NoPicture.png')
                "
              >
                <template v-slot:placeholder>
                  <v-layout align-center fill-height justify-center ma-0>
                    <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
              <v-card-text class="pl-0 pt-2">
                <div class="body-2">{{ `พันธุ์${varietyDetail.varietyname}` }}</div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex pr-1 pt-0 v-if="varietyDetails.length - 3 > 0" xs3>
            <v-card class="mouse-pointer" @click="isAllVariety()" color="transparent" elevation="0">
              <v-img :aspect-ratio="4 / 4" class="grey lighten-3" cover>
                <template v-slot:placeholder>
                  <v-layout align-center fill-height justify-center ma-0>
                    <v-flex text-xs-center xs12>
                      <div class="headline head-page">{{ `+${varietyDetails.length - 3}` }}</div>
                    </v-flex>
                  </v-layout>
                </template>
              </v-img>
              <v-card-text class="px-0 pt-2">
                <div class="body-2">พันธุ์อื่นๆ</div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'search-variey-box',
  data() {
    return {}
  },
  props: {
    rawDataText: {
      type: String,
      default: ''
    }
  },
  computed: {
    varietyId() {
      return window.atob(this.$route.params.varietyId ? this.$route.params.varietyId : null)
    },
    productId() {
      return window.atob(this.$route.params.productId)
    },
    varietyDetails() {
      if (this.varietyId) {
        return this.$store.getters['Variety/getVarietyDetails']
          .filter(item => item.varietyid != this.varietyId)
          .map(item => ({
            varietyid: item.varietyid,
            varietyname: item.varietyname,
            mainpictureurl: item.mainpictureurl
          }))
      } else {
        return this.$store.getters['Variety/getVarietyDetails'].map(item => ({
          varietyid: item.varietyid,
          varietyname: item.varietyname,
          mainpictureurl: item.mainpictureurl
        }))
      }
    }
  },
  created() {
    this.$store.dispatch('Variety/fetchVarietyDetails', this.productId)
  },
  methods: {
    onClickVariety(varietyId) {
      this.$router.push({
        name: 'variety-detail',
        params: {
          productId: window.btoa(this.productId),
          varietyId: window.btoa(varietyId)
        }
      })
    },
    isAllVariety() {
      this.$router.push({
        name: 'variety',
        params: {
          productId: window.btoa(this.productId)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
